import * as actionTypes from './constants'
import { api } from 'app/modules/pardot/api'

export function fetchPardotFieldsSuccess({ fields }) {
    return {
        type: actionTypes.FETCH_PARDOT_FIELDS_SUCCESS,
        fields
    }
}

export function fetchPardotMappingsSuccess({ mappings }) {
    return {
        type: actionTypes.FETCH_PARDOT_MAPPINGS_SUCCESS,
        mappings
    }
}

export function patchPardotMappingsSuccess({ mappings }) {
    return {
        type: actionTypes.PATCH_PARDOT_MAPPINGS_SUCCESS,
        mappings
    }
}

export function patchPardotMappingsError(err) {
    return {
        type: actionTypes.PATCH_PARDOT_MAPPINGS_ERROR,
        err
    }
}

export function patchPardotMappingsStart() {
    return {
        type: actionTypes.PATCH_PARDOT_MAPPINGS_START
    }
}

export function fetchPardotFields() {
    return dispatch => {
        api.fetchPardotFields().then(response => {
            dispatch(fetchPardotFieldsSuccess(response))
        })
    }
}

export function fetchPardotMappings() {
    return dispatch => {
        api.fetchPardotMappings().then(response => {
            dispatch(fetchPardotMappingsSuccess(response))
        })
    }
}

export function patchPardotMappings(mappings, successCB = () => { }) {
    return dispatch => {
        dispatch(patchPardotMappingsStart())
        api.patchPardotMappings(mappings)
            .then(response => {
                successCB()
                dispatch(patchPardotMappingsSuccess(response))
            })
            .catch(err => {
                dispatch(patchPardotMappingsError(err))
            })
    }
} 


// WEBPACK FOOTER //
// ./src/scripts/app/modules/pardot/actions.js